export default "__VITE_ASSET__Cqkwy2bS__"